import React, { Component } from "react";
import AppointmentCancellationComponent from "../components/appointments/appointmentCancellation";
import AppointmentCancellationFinalizationComponent from "../components/appointments/appointmentCancellationFinalization";
import AppointmentListComponent from "../components/appointments/appointmentList";
import AppointmentListLoginComponent from "../components/appointments/appointmentListLogin";
import FooterComponent from "../components/footer/footerComponent";
import HeaderComponent from "../components/header/header";


class AppointmentListPageComponent extends Component {

    // step 1 - login
    // step 2 - appointment list
    // step 3 - appointment cancellation
    // step 4 - appointment cancelled confirmation

    state = { 
        currentStep: 1,
        userEmail: null,
        userPhone: null,
        appointmentId: null
    };

    componentDidMount() {
        // get request parameters if there are any (they will be present if user clicked on an email link)
        const searchParams = new URLSearchParams(window.location.search);
        const appointmentId = searchParams.get('id');
        const userEmail = searchParams.get('email');
        const userPhone = searchParams.get('phone');
        let currentStep = 1;

        if(appointmentId){
            currentStep = 3;
        } else if(userEmail && userPhone){
            currentStep = 2;
        } else {
            currentStep = 1;
        }
        this.setState({userEmail: userEmail, userPhone:userPhone, appointmentId: appointmentId, currentStep: currentStep});
    }

    handleUserLogin = (retVal) => {
        this.setState({userEmail: retVal.email, userPhone:retVal.telefon, currentStep: 2});
    }

    handleAppointmentCancellationTry = (appointmentId) => {
        this.setState({appointmentId: appointmentId, currentStep: 3});
    }

    handleAppointmentCancellationRequest = (appointmentId) => {
        this.setState({appointmentId: appointmentId, currentStep: 4});
    }

    handleAppointmentCancellationConfirmation = () => {
        this.setState({currentStep: 2});
    }

    getComponentForActiveStep(){
        if(this.state.currentStep===1) return <AppointmentListLoginComponent onUserLogin={this.handleUserLogin}/>;
        else if(this.state.currentStep===2) return <AppointmentListComponent userEmail={this.state.userEmail} userPhone={this.state.userPhone} onAppointmentCancellationTry={this.handleAppointmentCancellationTry}/>;
        else if(this.state.currentStep===3) return <AppointmentCancellationComponent userEmail={this.state.userEmail} userPhone={this.state.userPhone} appointmentId={this.state.appointmentId} onAppointmentCancellationRequest={this.handleAppointmentCancellationRequest}/>;
        else if(this.state.currentStep===4) return <AppointmentCancellationFinalizationComponent userEmail={this.state.userEmail} userPhone={this.state.userPhone} appointmentId={this.state.appointmentId} onAppointmentCancellationConfirmation={this.handleAppointmentCancellationConfirmation}/>;
        else return <AppointmentListLoginComponent onUserLogin={this.handleUserLogin}/>;
    }

    render() { 
        return (
        <div>
            <HeaderComponent navBarMode="other"/>
            {this.getComponentForActiveStep()}
            <FooterComponent/>
        </div>);
    }
}
 
export default AppointmentListPageComponent;